export var NavigationErrors;
(function (NavigationErrors) {
    NavigationErrors["NO_SCROLLER_MEASUREMENTS"] = "Scroller measurements are not available";
    NavigationErrors["NO_ITEM_MEASUREMENTS"] = "Measurements for the specified index are not available";
    NavigationErrors["INVALID_NAVIGATION_MODE"] = "Invalid navigation mode";
    NavigationErrors["NO_CHANGE_IN_SCROLL_POSITION"] = "No change in scroll position";
    NavigationErrors["SCROLLER_REF_NOT_SET"] = "Scroller reference is not set.";
    NavigationErrors["INVALID_NAVIGATION_IN_PROGRESS"] = "Navigation already in progress";
    NavigationErrors["CANNOT_NAVIGATE_TO_NEXT"] = "Already at the last item. Cannot navigate to next.";
    NavigationErrors["CANNOT_NAVIGATE_TO_PREVIOUS"] = "Already at the first item. Cannot navigate to previous.";
    NavigationErrors["NO_CENTERED_ITEM"] = "No centered item in both axes to navigate from.";
    NavigationErrors["CANNOT_LOOP_WITHOUT_TOTAL_ITEMS_COUNT"] = "Cannot loop without a known total items count.";
    NavigationErrors["INDEX_OUT_OF_BOUNDS"] = "Navigation index is out of bounds.";
})(NavigationErrors || (NavigationErrors = {}));
//# sourceMappingURL=navigationErrors.js.map